/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Set_Color_WhiteInputs */



/**
* | output |
* | --- |
* | "Set Color White" |
*
* @param {Shortcut_Keys_Name_Set_Color_WhiteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_set_color_white = /** @type {((inputs?: Shortcut_Keys_Name_Set_Color_WhiteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Set_Color_WhiteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Set Color White")
	if (locale === "de") return /** @type {LocalizedString} */ ("Set Color White")
	if (locale === "it") return /** @type {LocalizedString} */ ("Set Color White")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Set Color White")
	if (locale === "es") return /** @type {LocalizedString} */ ("Set Color White")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Set Color White")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Set Color White")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Set Color White")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Set Color White")
	return /** @type {LocalizedString} */ ("Set Color White")
});